import { render, staticRenderFns } from "./First.vue?vue&type=template&id=7f3d7f46&scoped=true&lang=pug"
import script from "./First.vue?vue&type=script&lang=js"
export * from "./First.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f3d7f46",
  null
  
)

export default component.exports